import { render, staticRenderFns } from "./sku-card.vue?vue&type=template&id=6006c4ae&"
import script from "./sku-card.vue?vue&type=script&lang=js&"
export * from "./sku-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports